'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageBox = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(ImageBox, _Component);

  function ImageBox() {
    var _ref;

    var _temp, _this2, _ret;

    (0, _classCallCheck3.default)(this, ImageBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = ImageBox.__proto__ || (0, _getPrototypeOf2.default)(ImageBox)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
      counter: 0,
      dancingCount: 0,
      dragOver: false,
      empty: true,
      imagePlaceholder: '',
      interval: null
    }, _this2.dragCounter = 0, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(ImageBox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      if (this.props.image) {
        this.showField();
      } else {
        this.hideField();
      }
    }
  }, {
    key: 'openUploadDialog',
    value: function openUploadDialog() {
      document.getElementById('event-image-upload').click();
    }
  }, {
    key: 'dance',
    value: function dance(event) {
      var interval = this.state.interval;

      var _this = this;
      var _target = document.getElementById('buddy-dance');

      event.preventDefault();

      this.dragCounter++;

      if (!interval) {
        this.setState({
          dragOver: true,
          interval: setInterval(function () {
            _this.changeDanceClass(_target);
          }, 300)
        });
      }
    }
  }, {
    key: 'stopDancing',
    value: function stopDancing() {
      var interval = this.state.interval;


      this.dragCounter--;

      if (this.dragCounter === 0) {
        clearInterval(interval);
        document.getElementById('buddy-dance').className = 'icon-cg-buddy';
        this.setState({
          dancingCount: 0,
          dragOver: false,
          interval: null
        });
      }
    }
  }, {
    key: 'changeDanceClass',
    value: function changeDanceClass() {
      var _this3 = this;

      this.setState({
        dancingCount: this.state.dancingCount + 1
      }, function () {
        if (document.getElementById('buddy-dance')) {
          document.getElementById('buddy-dance').className = 'icon-cg-buddy-dancing' + _this3.state.dancingCount;
        }

        if (_this3.state.dancingCount >= 6) {
          _this3.setState({
            dancingCount: 0
          });
        }
      });
    }
  }, {
    key: 'readURL',
    value: function readURL(input) {
      var _this4 = this;

      var polyglot = this.props.polyglot;

      var reader = new FileReader();

      if (input.files && input.files[0]) {
        if (['image/jpeg', 'image/png', 'image/jpg'].indexOf(input.files[0].type) < 0) {
          alert('' + polyglot.t('imageBox.uploadImageTypePngOrJpg')); // eslint-disable-line no-alert
          return false;
        }
        if (input.files[0].size > 8000000) {
          alert('' + polyglot.t('imageBox.uploadSmallerFile')); // eslint-disable-line no-alert
          return false;
        }

        reader.onload = function (event) {
          _this4.setState({
            imagePlaceholder: event.target.result
          });
        };

        reader.readAsDataURL(input.files[0]);
      }
    }
  }, {
    key: 'uploadTarget',
    value: function uploadTarget(target) {
      this.stopDancing();
      this.showField();
      if (this.readURL(target) !== false) {
        this.props.handleChangeImage(target.files[0]);
      }
    }
  }, {
    key: 'uploadImage',
    value: function uploadImage(event) {
      event.preventDefault();
      this.uploadTarget(event.target);
    }
  }, {
    key: 'uploadDroppedImage',
    value: function uploadDroppedImage(event) {
      event.preventDefault();
      this.uploadTarget(event.dataTransfer);
    }
  }, {
    key: 'removeImage',
    value: function removeImage(event) {
      var _this5 = this;

      event.stopPropagation();
      event.preventDefault();
      this.setState({
        empty: true
      }, function () {
        _this5.props.handleDeleteImage(_this5.props.image ? _this5.props.image.id : null);
        _this5.dragCounter = 1;
        _this5.stopDancing();
      });
    }
  }, {
    key: 'showField',
    value: function showField() {
      this.setState({
        empty: false
      });
    }
  }, {
    key: 'hideField',
    value: function hideField() {
      this.setState({
        empty: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          image = _props.image,
          loading = _props.loading,
          polyglot = _props.polyglot;
      var _state = this.state,
          empty = _state.empty,
          dragOver = _state.dragOver,
          imagePlaceholder = _state.imagePlaceholder;


      return _react2.default.createElement(
        'span',
        null,
        empty && _react2.default.createElement(ImageBox.Empty, {
          onClickBuddy: this.openUploadDialog.bind(this),
          dragOver: dragOver,
          onDragOver: function onDragOver(event) {
            event.preventDefault();
          },
          onDragEnter: this.dance.bind(this),
          onDragLeave: this.stopDancing.bind(this),
          onDrop: this.uploadDroppedImage.bind(this),
          polyglot: polyglot,
          uploadImage: this.uploadImage.bind(this)
        }),
        !empty && _react2.default.createElement(ImageBox.Image, {
          removeImage: this.removeImage.bind(this),
          photoUrl: image && image.sizes && image.sizes.medium ? image.sizes.medium : '',
          imagePlaceholder: imagePlaceholder,
          loading: loading,
          onClickBuddy: this.openUploadDialog.bind(this),
          onDragOver: function onDragOver(event) {
            event.preventDefault();
          },
          onDrop: this.uploadDroppedImage.bind(this),
          polyglot: polyglot,
          uploadImage: this.uploadImage.bind(this)
        })
      );
    }
  }], [{
    key: 'Empty',
    value: function Empty(_ref2) {
      var uploadImage = _ref2.uploadImage,
          dragOver = _ref2.dragOver,
          onClickBuddy = _ref2.onClickBuddy,
          onDragOver = _ref2.onDragOver,
          onDragEnter = _ref2.onDragEnter,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          polyglot = _ref2.polyglot;

      var classes = (0, _classnames2.default)({
        'dashed-box': true,
        'event-image-box': true,
        'event-image-box-hover': dragOver
      });

      return _react2.default.createElement(
        'div',
        {
          className: classes,
          onClick: onClickBuddy,
          onDragOver: onDragOver,
          onDragEnter: onDragEnter,
          onDragLeave: onDragLeave,
          onDrop: onDrop
        },
        _react2.default.createElement('input', { type: 'file', id: 'event-image-upload', name: 'image', onChange: uploadImage }),
        _react2.default.createElement(
          'div',
          { className: 'event-image-placeholder' },
          _react2.default.createElement('span', { id: 'buddy-dance', className: 'icon-cg-buddy' })
        ),
        _react2.default.createElement(
          'label',
          null,
          polyglot.t('imageBox.image')
        )
      );
    }
  }, {
    key: 'Image',
    value: function Image(_ref3) {
      var removeImage = _ref3.removeImage,
          photoUrl = _ref3.photoUrl,
          imagePlaceholder = _ref3.imagePlaceholder,
          loading = _ref3.loading,
          uploadImage = _ref3.uploadImage,
          onClickBuddy = _ref3.onClickBuddy,
          onDragOver = _ref3.onDragOver,
          onDrop = _ref3.onDrop,
          polyglot = _ref3.polyglot;

      var classes = (0, _classnames2.default)({
        'line-box': true,
        'event-image-filled-box': true,
        'image-loading': loading
      });

      return _react2.default.createElement(
        'div',
        {
          className: classes,
          onClick: onClickBuddy,
          onDragOver: onDragOver,
          onDrop: onDrop
        },
        _react2.default.createElement('input', { type: 'file', id: 'event-image-upload', name: 'image', onChange: uploadImage }),
        _react2.default.createElement('img', { id: 'image-placeholder', src: photoUrl || imagePlaceholder, width: '100%', height: 'auto' }),
        _react2.default.createElement(
          'div',
          { onClick: removeImage, className: 'image-toolbar' },
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement('i', { className: 'icon-cg-trashcan' })
          )
        ),
        _react2.default.createElement(
          'label',
          null,
          polyglot.t('imageBox.image')
        )
      );
    }
  }]);
  return ImageBox;
}(_react.Component), _class.propTypes = {
  handleChangeImage: _propTypes2.default.func.isRequired,
  handleDeleteImage: _propTypes2.default.func.isRequired,
  image: _propTypes2.default.object,
  loading: _propTypes2.default.bool,
  polyglot: _propTypes2.default.object.isRequired
}, _temp2);
exports.default = ImageBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/ImageBox.js
// module id = 2214
// module chunks = 0